import logo from '../../assets/logo.svg'
import bottle from '../../assets/source.svg'
import cart from '../../assets/undraw_shopping_app_flsj 1.svg'

export default {
  logo,
  bottle,
  cart,
}